module.exports = __webpack_public_path__ + "img/error-feet.adbced08.svg";